var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99998 4.39536C6.53215 4.39536 3.72092 7.20659 3.72092 10.6744L3.72092 20.4418L16.279 20.4418L16.279 10.6744C16.279 7.20659 13.4678 4.39536 9.99998 4.39536ZM17.6744 20.4418L17.6744 10.6744C17.6744 6.43596 14.2384 3.00001 9.99998 3.00001C5.76152 3.00001 2.32558 6.43596 2.32558 10.6744L2.32558 20.4418H0.697673C0.312359 20.4418 0 20.7542 0 21.1395C0 21.5248 0.312359 21.8372 0.697673 21.8372L19.3023 21.8372C19.6876 21.8372 20 21.5248 20 21.1395C20 20.7542 19.6876 20.4418 19.3023 20.4418H17.6744Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8604 24.6279C11.8604 25.0132 11.5481 25.3255 11.1628 25.3255L8.83719 25.3255C8.45187 25.3255 8.13952 25.0132 8.13952 24.6279C8.13952 24.2426 8.45187 23.9302 8.83719 23.9302L11.1628 23.9302C11.5481 23.9302 11.8604 24.2426 11.8604 24.6279Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99998 2.06978C9.7431 2.06978 9.53486 2.27802 9.53486 2.5349C9.53486 2.79177 9.7431 3.00001 9.99998 3.00001C10.2569 3.00001 10.4651 2.79177 10.4651 2.5349C10.4651 2.27802 10.2569 2.06978 9.99998 2.06978ZM8.13951 2.5349C8.13951 1.5074 8.97247 0.674438 9.99998 0.674438C11.0275 0.674438 11.8604 1.5074 11.8604 2.5349C11.8604 3.5624 11.0275 4.39536 9.99998 4.39536C8.97247 4.39536 8.13951 3.5624 8.13951 2.5349Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.971402418ac409592cb1ada282e39ba7.svg";
export { ForwardRef as ReactComponent };